



















import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import ImageCropper from "@/components/ImageCropper";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "AvatarCropModal",
  components: { ImageCropper, ModalView },
  props: {
    show: { type: Boolean, required: true },
    avatar: { type: String, required: true },
    user: { type: Object as PropType<UserPublicData>, required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const handleCropImage = (blob: Blob) => {
      const file = new File([blob], `${props.user.screenName}_avatar.jpg`, { type: "image/jpeg" });
      emit("imageCropped", file);
    };
    return { handleCropImage };
  },
});
